// extracted by mini-css-extract-plugin
module.exports = {"root":"Caption_root__3_hLY","caption":"Caption_caption__3XnAF","captionLink":"Caption_captionLink__ucqdu"};